import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Badge,
} from "reactstrap";
import { updateUser, getCurrentUser } from "../../../store/slices/usersSlice";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faEnvelope,
  faPhone,
  faCalendar,
  faCheckCircle,
  faShieldAlt,
  faIdBadge,
} from "@fortawesome/free-solid-svg-icons";

export default function ManageProfile() {
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector((state) => state.auth);
  const [user, setuser] = useState({
    full_name: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    birth_date: "",
  });
  const token = useSelector((state) => state.auth.token);

  const [loading, setLoading] = useState(false);

  async function getUser() {
    const resultUser = await dispatch(
      getCurrentUser({ id: currentUser.id, token }),
    );
    console.log(resultUser, "resultUser---------");
    setuser(resultUser.payload || {});
  }

  useEffect(() => {
    getUser();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setuser((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = { ...user };
      if (!payload.password) {
        delete payload.password;
      }

      const userId = user?.id || user?.ID;

      if (!userId) {
        toast.error("User ID not found.");
        setLoading(false);
        return;
      }

      const resultAction = await dispatch(
        updateUser({ id: userId, payload, token }),
      );

      if (updateUser.fulfilled.match(resultAction)) {
        toast.success("Profile updated successfully!");
        // Optionally update the local user token/state if needed
      } else {
        toast.error(
          resultAction.payload?.message || "Failed to update profile.",
        );
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while updating profile.");
    } finally {
      setLoading(false);
    }
  };

  const getInitials = (name) => {
    if (!name) return "U";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <Container
      fluid={true}
      className="p-4"
      style={{ backgroundColor: "#f8f9fc", minHeight: "100vh" }}
    >
      <Row className="justify-content-center">
        <Col>
          <div className="mb-4">
            <h2
              style={{
                fontWeight: "700",
                color: "#2b2b2b",
                letterSpacing: "-0.5px",
              }}
            >
              My Account
            </h2>
            <p className="text-muted">Manage your profile information.</p>
          </div>

          <Row>
            {/* Left Profile Overview Column */}
            <Col md="4" className="mb-4">
              <Card
                className="border-0 shadow-sm rounded-4 overflow-hidden"
                style={{
                  background: "linear-gradient(145deg, #ffffff, #f3f4f9)",
                  transition: "transform 0.3s ease",
                }}
              >
                <CardBody className="text-center p-5">
                  <div
                    className="mx-auto mb-4 d-flex align-items-center justify-content-center shadow-lg"
                    style={{
                      width: "120px",
                      height: "120px",
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      color: "#fff",
                      fontSize: "2.5rem",
                      fontWeight: "bold",
                    }}
                  >
                    {getInitials(user?.full_name)}
                  </div>

                  <h4 className="mb-1 fw-bold" style={{ color: "#333" }}>
                    {user?.full_name || "User"}
                    {user?.otp_verified && (
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        className="text-success ms-2 fs-6"
                        title="Verified Account"
                      />
                    )}
                  </h4>
                  <p className="text-muted mb-3 font-monospace small">
                    @{user?.username}
                  </p>
                </CardBody>
              </Card>
            </Col>

            {/* Right Editing Form Column */}
            <Col md="8">
              <Card className="border-0 shadow-sm rounded-4">
                <CardBody className="p-5">
                  <h5 className="mb-4 fw-bold" style={{ color: "#444" }}>
                    Profile Settings
                  </h5>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label className="fw-semibold text-muted small text-uppercase">
                            First Name
                          </Label>
                          <div className="input-group">
                            <span className="input-group-text bg-light border-end-0">
                              <FontAwesomeIcon
                                icon={faUser}
                                className="text-muted"
                              />
                            </span>
                            <Input
                              type="text"
                              name="first_name"
                              value={user.first_name}
                              onChange={handleInputChange}
                              className="border-start-0 bg-light px-3 py-2"
                              style={{
                                borderRadius: "0 0.5rem 0.5rem 0",
                                boxShadow: "none",
                                color: "black",
                              }}
                              placeholder="john"
                              
                            />
                          </div>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label className="fw-semibold text-muted small text-uppercase">
                            Last Name
                          </Label>
                          <div className="input-group">
                            <span className="input-group-text bg-light border-end-0">
                              <FontAwesomeIcon
                                icon={faUser}
                                className="text-muted"
                              />
                            </span>
                            <Input
                              type="text"
                              name="last_name"
                              value={user.last_name}
                              onChange={handleInputChange}
                              className="border-start-0 bg-light px-3 py-2"
                              style={{
                                borderRadius: "0 0.5rem 0.5rem 0",
                                boxShadow: "none",
                                color: "black",
                              }}
                              placeholder="Doe"
                              
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label className="fw-semibold text-muted small text-uppercase">
                            Full Name
                          </Label>
                          <div className="input-group">
                            <span className="input-group-text bg-light border-end-0">
                              <FontAwesomeIcon
                                icon={faUser}
                                className="text-muted"
                              />
                            </span>
                            <Input
                              type="text"
                              name="full_name"
                              value={user.full_name}
                              onChange={handleInputChange}
                              className="border-start-0 bg-light px-3 py-2"
                              style={{
                                borderRadius: "0 0.5rem 0.5rem 0",
                                boxShadow: "none",
                                color: "black",
                              }}
                              placeholder="John Doe"
                              
                            />
                          </div>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label className="fw-semibold text-muted small text-uppercase">
                            Birth Date
                          </Label>
                          <div className="input-group">
                            <span className="input-group-text bg-light border-end-0">
                              <FontAwesomeIcon
                                icon={faCalendar}
                                className="text-muted"
                              />
                            </span>
                            <Input
                              type="datetime"
                              name="birth_date"
                              value={user.birth_date}
                              onChange={handleInputChange}
                              className="border-start-0 bg-light px-3 py-2"
                              style={{
                                borderRadius: "0 0.5rem 0.5rem 0",
                                boxShadow: "none",
                                color: "black",
                              }}
                              placeholder="1990-01-01"
                              
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md="6">
                        <FormGroup>
                          <Label className="fw-semibold text-muted small text-uppercase">
                            Email Address
                          </Label>
                          <div className="input-group">
                            <span className="input-group-text bg-light border-end-0">
                              <FontAwesomeIcon
                                icon={faEnvelope}
                                className="text-muted"
                              />
                            </span>
                            <Input
                              type="email"
                              name="email"
                              value={user.email}
                              onChange={handleInputChange}
                              className="border-start-0 bg-light px-3 py-2"
                              style={{
                                borderRadius: "0 0.5rem 0.5rem 0",
                                boxShadow: "none",
                                color: "black",
                              }}
                              placeholder="john@example.com"
                              
                            />
                          </div>
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label className="fw-semibold text-muted small text-uppercase">
                            Mobile Number
                          </Label>
                          <div className="input-group">
                            <span className="input-group-text bg-light border-end-0">
                              <FontAwesomeIcon
                                icon={faPhone}
                                className="text-muted"
                              />
                            </span>
                            <Input
                              type="text"
                              name="mobile"
                              value={user.mobile}
                              onChange={handleInputChange}
                              className="border-start-0 bg-light px-3 py-2"
                              style={{
                                borderRadius: "0 0.5rem 0.5rem 0",
                                boxShadow: "none",
                                color: "black",
                              }}
                              placeholder="+1 234 567 890"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>

                    <div className="mt-2 d-flex justify-content-end">
                      <Button
                        type="submit"
                        disabled={loading}
                        className="px-5 py-2 fw-bold rounded-pill text-white border-0 shadow-sm hover-elevate"
                        style={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          transition: "all 0.3s ease",
                          cursor: loading ? "not-allowed" : "pointer",
                        }}
                        onMouseOver={(e) => {
                          if (!loading)
                            e.currentTarget.style.transform =
                              "translateY(-2px)";
                        }}
                        onMouseOut={(e) => {
                          if (!loading)
                            e.currentTarget.style.transform = "translateY(0)";
                        }}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Saving Changes...
                          </>
                        ) : (
                          "Save Changes"
                        )}
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
